export default __webpack_public_path__ + "static/media/error-image.2206385c.jpg";